import { render, staticRenderFns } from "./chat-old.vue?vue&type=template&id=0af867a5&scoped=true"
import script from "./chat-old.vue?vue&type=script&lang=js"
export * from "./chat-old.vue?vue&type=script&lang=js"
import style0 from "./chat-old.vue?vue&type=style&index=0&id=0af867a5&prod&lang=css"
import style1 from "./chat-old.vue?vue&type=style&index=1&id=0af867a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af867a5",
  null
  
)

export default component.exports